var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSeabed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1919.71 829.66"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "seabed_svg__a",
    x1: 962.78,
    y1: 92.7,
    x2: 957.29,
    y2: 762.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abe39d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e4d884"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 80.61C87.54 69.23 206.2 57 379.26 53.65c135.56-2.63 168.67 4.18 441.53 11 127.2 3.17 286.81 5.84 475.93 3.84 205.64-2.18 301.28-8.34 409.6-24.68C1796.69 30.15 1868 13.2 1919.71 0c0 357.29-.08 596.33-.08 828.71-643.19 3.29-1276.44-3.29-1919.63 0z",
    fill: "url(#seabed_svg__a)",
    "data-name": "Layer 4"
  }))));
}

export default SvgSeabed;